export default __webpack_public_path__ + "static/media/mic_off.3ff38ae6.svg";